import React, { useRef, useEffect } from 'react';

function MessageInput({ input, setInput, sendMessage, isLoading, stopGeneration, isPrivate }) {
  const textareaRef = useRef(null);

  // Ajustează înălțimea textarea-ului în funcție de conținut
  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${Math.min(textarea.scrollHeight, 180)}px`;
    }
  };

  // Ajustează înălțimea la schimbarea inputului
  useEffect(() => {
    adjustTextareaHeight();
  }, [input]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage(e);
    }
  };

  return (
    <form onSubmit={sendMessage}>
      <div className="relative">
        <textarea
          ref={textareaRef}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Scrie un mesaj..."
          rows="1"
          style={{ minHeight: '60px', maxHeight: '180px', overflow: 'auto' }}
          className={`w-full p-3 pr-24 rounded-lg border resize-none ${
            isPrivate 
              ? 'bg-gray-900 text-white border-gray-700 focus:border-gray-600' 
              : 'bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 border-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-400'
          } focus:outline-none focus:ring-2 ${
            isPrivate 
              ? 'focus:ring-gray-500' 
              : 'focus:ring-blue-500 dark:focus:ring-blue-400'
          } transition-colors`}
          disabled={isLoading}
        />
        <div className="absolute bottom-3 right-3 flex space-x-2">
          {isLoading ? (
            <button
              type="button"
              onClick={stopGeneration}
              className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
            >
              Stop
            </button>
          ) : (
            <button
              type="submit"
              className={`px-3 py-1 ${
                isPrivate 
                  ? 'bg-gray-700 hover:bg-gray-600 text-white' 
                  : 'bg-blue-500 hover:bg-blue-600 text-white'
              } rounded transition-colors`}
              disabled={!input.trim()}
            >
              Trimite
            </button>
          )}
        </div>
      </div>
    </form>
  );
}

export default MessageInput; 